import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const NpsSurveysPage = lazy(() => import('./pages/NpsSurveysPage'));
const CsatSurveysPage = lazy(() => import('./pages/CsatSurveysPage'));
const FeedbackCollectionPage = lazy(() => import('./pages/FeedbackCollectionPage'));
const FeedbackActionsPage = lazy(() => import('./pages/FeedbackActionsPage'));
const FeedbackLoopPage = lazy(() => import('./pages/FeedbackLoopPage'));

export const FeedbackRoutes: RouteObject = {
  path: 'feedback',
  element: <ModuleGuard moduleId="support.feedback" />,
  handle: { crumb: 'Customer Feedback' },
  children: [
    { index: true, element: <Navigate to="nps-surveys" replace /> },
    { path: 'nps-surveys', element: <NpsSurveysPage />, handle: { crumb: 'NPS Surveys' } },
    { path: 'csat-surveys', element: <CsatSurveysPage />, handle: { crumb: 'CSAT Surveys' } },
    { path: 'feedback-collection', element: <FeedbackCollectionPage />, handle: { crumb: 'Feedback Collection' } },
    { path: 'feedback-actions', element: <FeedbackActionsPage />, handle: { crumb: 'Feedback Actions' } },
    { path: 'feedback-loop', element: <FeedbackLoopPage />, handle: { crumb: 'Feedback Loop' } },
  ],
};
